import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import Icon from "../../Icon";
import CardSkeleton from "../../ui/Skeleton/CardSkeleton";
import { FormatInt } from "../../../utils/FormatData";
import { classNames } from "../../../utils/helpers";
import _Button from "../../generic/_Button";
import _ModalHealthApi from "../../modal/dashboard/sms/_ModalHealthApi";
import { Tooltip } from "../../ui/Tooltip";
const HealthApi = ({ data, loading = false }) => {
  const [visible, setVisible] = useState(false);
  const safe = data || {};

  const { pending, received, sent, errors } = useMemo(() => {
    const received = Number(safe.i_received ?? 0);
    const sent = Number(safe.i_message ?? 0);
    const errors = Number(safe.i_errors ?? 0);

    const pending = received - (sent + errors);
    const isOk = pending === 0;

    return {
      received,
      sent,
      errors,
      pending,
      isOk,
    };
  }, [safe]);

  if (loading) return <CardSkeleton />;

  return (
    <div
      className={classNames(
        "flex flex-col px-4 py-2 transition-all duration-300 transform rounded-lg hover:scale-105",
        {
          "bg-green-50": pending === 0,
          "bg-red-50": pending > 100,
          "bg-yellow-50": pending > 0 && pending < 100,
        },
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <div
          className={classNames(
            "text-lg font-bold text-green-700 dark:text-background-light pb-3",
            {
              "text-green-700": pending === 0,
              "text-red-700": pending > 100,
              "text-yellow-700": pending > 0 && pending < 100,
            },
          )}
        >
          Mensajes API por procesar
        </div>
        <Icon
          icon="api"
          className={classNames({
            "text-green-600": pending === 0,
            "text-red-600": pending > 100,
            "text-yellow-600": pending > 0 && pending < 100,
          })}
          size={36}
        />
      </div>

      <p
        className={classNames(
          `mt-2 text-3xl font-bold text-[#101922] dark:text-background-light`,
          {
            "text-green-700": pending === 0,
            "text-red-700": pending > 100,
            "text-yellow-700": pending > 0 && pending < 100,
          },
        )}
      >
        {FormatInt(pending)}
      </p>

      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
        <Tooltip message="Mensajes enviados" placement="top">
          <div className="flex items-center gap-1 text-slate-700">
            <span className="material-symbols-outlined">arrow_upward_alt</span>
            <span>{FormatInt(sent)}</span>
          </div>
        </Tooltip>

        <Tooltip message="Mensajes recibidos" placement="top">
          <div className="flex items-center gap-1 text-slate-700">
            <span className="material-symbols-outlined">
              arrow_downward_alt
            </span>
            <span>{FormatInt(received)}</span>
          </div>
        </Tooltip>
        <Tooltip message="Mensajes con error" placement="top">
          <div className="flex items-center gap-1 text-red-700">
            <span className="material-symbols-outlined">error</span>
            <span>{FormatInt(errors)}</span>
          </div>
        </Tooltip>
      </div>

      <_Button
        icon="read_more"
        style="none"
        styleIcon="outlined"
        title="Ver Detalles"
        onClick={() => setVisible(true)}
        className="p-0 mt-[5px]"
      />
      <_ModalHealthApi
        visible={visible}
        title="Detalles API"
        onClose={() => setVisible(false)}
      />
    </div>
  );
};

HealthApi.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default HealthApi;
